
module.exports = [
  {
    id: "policyName",
    fieldName: "Policy Name",
  },
  {
    id: "policyOwner",
    fieldName: "Policy Owner",
  },
  {
    id: "location",
    fieldName: "Location",
  },
  {
    id: "client",
    fieldName: "Client",
  }
  
];